<template>
  <div>
    <div v-if="confirmText" @click="close" class="box">
      <div class="wrapper">
        <img :src="iconBg" class="title-bg"/>
        <div :maxFontZoomScale="1.0" class="title">合格投资人认定</div>
        <div class="explain-w">
          <div :maxFontZoomScale="1.0" class="explain">{{ explain }}</div>
        </div>
        <div class="btn-w" @click.stop="clickConfirm">
          <div :maxFontZoomScale="1.0" class="btn-txt">{{ confirmText }}</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { asyncSetAuditPopRecord } from './investors-trace';

export default {
  props: {
    confirmText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      iconBg: 'https://j5.dfcfw.com/sc/image/202203/20220316081044.png',
      explain: '若您有意进行私募资产管理产品投资，'
          + '请确认您符合法规规定的“合格投资者”标准，'
          + '即具备相应的风险识别能力和风险承担能力，'
          + '投资于单只产品符合产品合同约定的起投金额，'
          + '且需具有2年以上投资经历，并满足以下条件之一：'
          + '1、家庭金融资产≥500万；2、家庭金融净资产≥300万；'
          + '3、近3年本人年均收入≥50万。并且，'
          + '您对天天基金及其平台销售的私募资产管理产品有一定的了解，是天天基金的优质注册客户。',
    };
  },

  watch: {
    confirmText: {
      handler() {
        console.log('yyz----confirmText', this.confirmText);
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    // 关闭弹窗
    close() {
      multi.$router.back({
        delta: 1,
      });
    },

    // 点击确认
    async clickConfirm() {
      if (this.confirmText === '登录查看') {
        const webPlatf = multi.$system.webPlatform;
        if (webPlatf === 'wxmp') {
          // eslint-disable-next-line no-undef
          wx.miniProgram.redirectTo({
            url: '/pages/fund-login/home/index?source=lowcode',
          });
        }
        this.$parent.confirmText = '';
        this.confirmText = '';
      } else {
        asyncSetAuditPopRecord();
        this.$parent.confirmText = '';
        this.confirmText = '';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  flex: 1;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  position: fixed;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000000;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 560px;
  background-color: #ffffff;
  border-radius: 24px;
}

.title-bg {
  /* px2wx:change next */
  width: 64px;
  height: 64px;
  margin-top: 32px;
}

.title {
  font-family: PingFang-SC-Bold;
  font-size: 36px;
  color: #000000;
  text-align: center;
  line-height: 54px;
  font-weight: 700;
  margin-top: 12px;
}

.explain {
  font-size: 32px;
  line-height: 44px;
  color: #000000;
  text-align: justify;
  padding-left: 56px;
  padding-right: 56px;
  margin-top: 24px
}

.btn-w {
  height: 80px;
  justify-content: center;
  align-items: center;
  margin-bottom: 48px;
  margin-top: 48px;
  background-image: linear-gradient(to left, #dca057, #fcd8ae);
  border-radius: 47px;
}

.btn-bg {
  height: 80px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  left: 0;
}

.btn-txt {
  font-family: PingFang-SC-Bold;
  font-size: 36px;
  color: #4A2905;
  text-align: center;
  line-height: 36px;
  font-weight: 700;
  padding: 20px 56px 24px 56px;
}

.close-bg {
  position: absolute;
  top: 32px;
  right: 32px;
  width: 24px;
  height: 24px;
}
</style>
